/* tslint:disable */
/* eslint-disable */
export enum ArcHospiStatusCode {
  Created = 'CREATED',
  Started = 'STARTED',
  Overwritten = 'OVERWRITTEN',
  Deleted = 'DELETED',
  Updated = 'UPDATED',
  Error = 'ERROR'
}
